// src/components/UserMenu.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// MUI
import { Menu, MenuItem, Divider } from "@mui/material";

// Ваши кастомные компоненты и стили
import Icon from "../UI/Icon/Icon.tsx";
import { ReactComponent as CaretSvg } from "../icons/Caret.svg";    // Стрелка
import { ReactComponent as UserAvatarSvg } from "../icons/UserAvatar.svg"; // иконка пользователя
import {
  UserMenuContainer,
  HeaderText,
  ArrowButton
} from "./UserMenuStyles.ts";  // стили UserMenu

interface UserMenuProps {
  userEmail?: string;
  onLogout?: () => void;
}

const UserMenu: React.FC<UserMenuProps> = ({ userEmail, onLogout }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  // Берём email из пропа или из localStorage
  const email = userEmail || localStorage.getItem("user_email") || "";

  // Управление открытием меню
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  // Обработчики пунктов меню
  const handleProfile = () => {
    handleCloseMenu();
    navigate("/profile");
  };
  const handleSettings = () => {
    handleCloseMenu();
    navigate("/settings");
  };
  const handleLogout = () => {
    handleCloseMenu();
    if (onLogout) {
      onLogout();
    } else {
      // Пример простого логаута
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      navigate("/user/login");
    }
  };

  // Смена языка
  const handleLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    handleCloseMenu();
  };

  return (
    <UserMenuContainer>
      {/* Иконка пользователя (аватар) */}
      <Icon SvgComponent={UserAvatarSvg} size={20} style={{ marginRight: 6 }} />

      {/* Email */}
      <HeaderText>{email}</HeaderText>

      {/* Кнопка со стрелкой - открываем меню */}
      <ArrowButton
        onClick={handleOpenMenu}
        aria-controls={open ? "user-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <Icon SvgComponent={CaretSvg} size={16} />
      </ArrowButton>

      {/* Выпадающее меню */}
      <Menu
        id="user-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={handleProfile}>{t("profile")}</MenuItem>
        <MenuItem onClick={handleSettings}>{t("settings")}</MenuItem>

        {/* Разделитель */}
        <Divider sx={{ my: 0.5 }} />

        {/* Пункты переключения языка */}
        <MenuItem onClick={() => handleLanguage("ru")}>RU</MenuItem>
        <MenuItem onClick={() => handleLanguage("en")}>EN</MenuItem>

        <Divider sx={{ my: 0.5 }} />

        <MenuItem onClick={handleLogout}>{t("logout")}</MenuItem>
      </Menu>
    </UserMenuContainer>
  );
};

export default UserMenu;
